import { ModalType } from '@hooks/useModal.hook';
import { isDesktopApp } from '@launcher/utils';
import { logger } from '@services/logger/logger.service';
import { notificationWindow } from '@services/notificationWindow/notificationWindow.service';
import {
  NotificationActions,
  NotificationActionTypes,
} from '@store/notificationWindow/notificationWindow.action';
import { NavigateFunction } from 'react-router-dom';
import { all, getContext, takeEvery } from 'redux-saga/effects';

/**
 * On desktop, we send notification actions to the notification
 * window so they are dispatched in the right window.
 */
export function* handleNotificationAsync({ payload, type }: ReturnType<NotificationActionTypes>) {
  if (isDesktopApp() && notificationWindow.isInitialized) {
    try {
      yield notificationWindow.showNotifWindow();
    } catch (error) {
      yield notificationWindow.init();
      yield notificationWindow.showNotifWindow();
      logger.warn('DESKTOP', 'notificationWindow was reset', {
        error: error instanceof Error ? error.message : JSON.stringify(error as any),
      });
    }
    notificationWindow.sendMessageToNotificationWindow(type, payload);
  } else {
    // Note: We can't use the useModal hook here since this is a saga running outside React components
    // So we directly manipulate the URL to open the modal, maintaining the same behavior as useModal.openModal()
    const navigate: NavigateFunction = yield getContext('navigate');
    const searchParams = new URLSearchParams(window.location.search);

    searchParams.set('modal', ModalType.documentJobNotification);
    navigate(`?${searchParams}`, { replace: true });
  }
}

export function* notificationWindowSagas() {
  yield all(
    Object.values(NotificationActions).map((action) => takeEvery(action, handleNotificationAsync)),
  );
}
